import C from "../constants";

export default function user_detail(state = {}, payload) {
    let { type, key, data } = payload;
    switch (type) {
      case C.UPDATE_USER_DETAILS:
    return { ...state, [key]:data };
      default:
        return state;
    }
  }